<template>
    <section class="col-sm-4 api-box" @click="goToPage()">
        <div class="api-box-inner">
            <template v-if="apiTest">
                <span class="box-title">{{apiTest.name}}</span>
                <ul>
                    <li><i class="fas fa-sync"></i> {{intervalToText(apiTest.interval)}}</li>
                    <li><i class="fas fa-check"></i> {{apiTest.checks.success}} passes</li>
                    <li><i class="fas fa-exclamation-triangle"></i> {{apiTest.checks.failed}} errors</li>
                </ul>
                <div class="status success" v-if="(100 - ((apiTest.checks.failed/apiTest.checks.success) * 100)) >= ratio_warning">
                    <i class="fas fa-check"></i>
                </div>
                <div class="status waiting" v-else-if="apiTest.checks.failed == 0 && apiTest.checks.success == 0">
                    <i class="fas fa-hourglass-half"></i>
                </div>
                <div class="status error" v-else>
                    <i class="fas fa-times"></i>
                </div>
            </template>
            <template v-else>
                <span class="add-endpoint">+</span>
            </template>
        </div>
    </section>
</template>

<script>
    import {intervalToText} from "../logic/endpoints"
    import constants from "../constants"

    export default {
        name: 'APITestBox',
        props:{
            apiTest: Object,
            empty: Boolean
        },
        data(){
            return {
                ratio_warning: constants.RATIO_WARNING
            }
        },
        components: {},
        methods: {
            intervalToText: intervalToText,
            goToPage: function(){
                if(this.apiTest){
                    this.$router.push({name: 'api-test-single', params: {'test_id': this.apiTest.id}})
                }else{
                    this.$router.push({name: "api-test-create"})
                }
            }
        },
        mounted: function() {}
    }
</script>

<style scoped>
    .box-title{
        font-size: 16px;
        margin-bottom: 13px;
        display: block;
    }
    .api-box-inner ul li{
        margin-bottom: 7px;
    }
    .api-box-inner ul li i{
        margin-right: 3px;
    }
    .api-box .status.success,
    .api-box .status.success i{
        color: #8BC34A;
        border-color: #8BC34A;
    }
    .api-box .status.error,
    .api-box .status.error i{
        color: #F44336;
        border-color: #F44336;
    }
    .api-box .status.waiting,
    .api-box .status.waiting i{
        color: #00BCD4;
        border-color: #00BCD4;
    }
    .status{
        width: 65px;
        height: 65px;
        border: 1px solid;
        text-align: center;
        line-height: 65px;
        border-radius: 100%;
        position: absolute;
        right: 30px;
        top: 50%;
        font-size: 22px;
        margin-top: -33px;
    }
    .api-box{
        margin-bottom: 30px;
        cursor: pointer;
    }
    .api-box-inner{
        background: #fff;
        padding: 15px 18px;
        height: 145px;
        font-size: 13px;
        box-shadow: 1px 1px 3px #d0d3d6;
    }
    .add-endpoint{
        font-size: 38px;
        font-weight: 200;
        text-align: center;
        display: block;
        margin: 28px 0px;
    }
    @media (max-width: 945px) {
        .api-box .status.error, .api-box .status.error{
            color: #F44336;
            border-color: #F44336;
            width: 4px;
            height: 100%;
            top: 0px;
            border-radius: 0px;
            background: #F44336;
            margin-top: 0px;
            line-height: 0pc;
            font-size: 0px;
            left: 12px;
        }
        .api-box .status.success, .api-box .status.success{
            color: #8BC34A;
            border-color: #8BC34A;
            width: 4px;
            height: 100%;
            top: 0px;
            border-radius: 0px;
            background: #8BC34A;
            margin-top: 0px;
            line-height: 0pc;
            font-size: 0px;
            left: 12px;
        }
        .api-box .status.waiting, .api-box .status.waiting{
            color: #00BCD4;
            border-color: #00BCD4;
            width: 4px;
            height: 100%;
            top: 0px;
            border-radius: 0px;
            background: #00BCD4;
            margin-top: 0px;
            line-height: 0pc;
            font-size: 0px;
            left: 12px;
        }
    
    }
</style>
